import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import type { Entity } from '@backstage/catalog-model';
import { tabVisible } from '@platform/plugin-platform-react';

/**
 * Les composants, et les ressources ANNOTEES qui n'ont pas deja leur propre
 * experience.
 *
 * L'onglet Kubernetes des ressources vivait dans `genericResourcePage`
 * (`EntityPage.tsx`, phase 4b tache 8) : il exigeait l'annotation
 * `backstage.io/kubernetes-id` et excluait explicitement les ressources
 * `database` et `cache`, qui avaient leur page a elles. Les deux conditions
 * sont reprises ici telles quelles.
 *
 * Changement visible assume : sur une ressource, l'onglet s'appelait
 * « Kubernetes » et ne montrait que `InfrastructureContent`. Il devient
 * l'onglet « Ressources », à côté d'« ArgoCD » et des tâches planifiées, et gagne
 * `PodMetricsCard` — le meme contenu que sur un composant.
 */
const aSaPropreExperience = (entity: Entity): boolean => {
  const t = (entity.spec?.type ?? '').toString().toLowerCase();
  return t === 'database' || t === 'cache';
};

const porteKubernetes = (entity: Entity): boolean => {
  const kind = entity.kind?.toLowerCase();
  if (kind === 'component') return true;
  if (kind !== 'resource') return false;
  return (
    !aSaPropreExperience(entity) &&
    Boolean(entity.metadata.annotations?.['backstage.io/kubernetes-id'])
  );
};

const resourcesContent = EntityContentBlueprint.make({
  name: 'resources',
  params: {
    path: '/kubernetes',
    title: 'Workloads',
    filter: tabVisible('kubernetes', porteKubernetes),
    loader: () =>
      import('./KubernetesResourcesContent').then(m => (
        <m.KubernetesResourcesContent />
      )),
  },
});

export default createFrontendPlugin({
  pluginId: 'kubernetes',
  extensions: [resourcesContent],
});
